import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import DataGridConfigEditor from './typeEditors/DataGridConfigEditor'
import PresentationTableConfigEditor from './typeEditors/PresentationTableConfigEditor'
import MetricConfigEditor from './typeEditors/MetricConfigEditor'
import ChartConfigEditor from './typeEditors/ChartConfigEditor'
import HierarchicalTableConfigEditor from './typeEditors/HierarchicalTableConfigEditor'
import HierarchicalGridConfigEditor from './typeEditors/HierarchicalGridConfigEditor'

function PresentationDetailPanel ({
  optionCode,
  optionData,
  allPurposes,
  onUpdateConfig
}) {
  const handleConfigUpdate = useCallback((updatedConfig) => {
    onUpdateConfig(optionCode, updatedConfig)
  }, [onUpdateConfig, optionCode])

  if (!optionCode || !optionData) {
    return (
      <div style={{
        padding: '32px',
        textAlign: 'center',
        color: 'var(--text-color-subtle)',
        paddingLeft: '32px'
      }}
      >
        <p>Select a presentation option to view and edit details</p>
      </div>
    )
  }

  return (
    <div style={{ paddingLeft: '24px', overflowY: 'auto' }}>
      {/* Header */}
      <div style={{ marginBottom: '16px' }}>
        <h3 style={{ marginBottom: '4px' }}>{optionData.displayName}</h3>
        <div style={{ fontSize: '0.875rem', color: 'var(--text-color-subtle)' }}>
          {optionData.type} • {optionCode}
        </div>
        {optionData.description && (
          <p style={{ marginTop: '8px', fontSize: '0.875rem', color: 'var(--text-color-subtle)' }}>
            {optionData.description}
          </p>
        )}
      </div>

      {/* Type-specific Configuration Editor */}
      {optionData.type === 'Data Grid' && (
        <DataGridConfigEditor
          config={optionData.config}
          allPurposes={allPurposes}
          onUpdate={handleConfigUpdate}
        />
      )}
      {optionData.type === 'Presentation Table' && (
        <PresentationTableConfigEditor
          config={optionData.config}
          allPurposes={allPurposes}
          onUpdate={handleConfigUpdate}
        />
      )}
      {optionData.type === 'Metric' && (
        <MetricConfigEditor
          config={optionData.config}
          allPurposes={allPurposes}
          onUpdate={handleConfigUpdate}
        />
      )}
      {optionData.type === 'Chart' && (
        <ChartConfigEditor
          config={optionData.config}
          allPurposes={allPurposes}
          onUpdate={handleConfigUpdate}
        />
      )}
      {optionData.type === 'Hierarchical Table' && (
        <HierarchicalTableConfigEditor
          config={optionData.config}
          allPurposes={allPurposes}
          onUpdate={handleConfigUpdate}
        />
      )}
      {optionData.type === 'Hierarchical Grid' && (
        <HierarchicalGridConfigEditor
          config={optionData.config}
          allPurposes={allPurposes}
          onUpdate={handleConfigUpdate}
        />
      )}
    </div>
  )
}

PresentationDetailPanel.propTypes = {
  optionCode: PropTypes.string,
  optionData: PropTypes.object,
  allPurposes: PropTypes.object.isRequired,
  onUpdateConfig: PropTypes.func.isRequired
}

export default PresentationDetailPanel
